<template>
    <div v-if="messageKey" class="wrap">
        <div class="font-1 title">
            ironSource Network Configuration
        </div>
        <div v-if="messageKey === CONTACT_US" class="font-4 message">
            In order to go live <a :href="contactUsLink" target="_blank">Contact Us &#x00BB;</a>
        </div>
        <div v-else-if="messageKey === PROVIDE_MORE_DETAILS" class="font-4 message">
            In order to go live, you must first <button
                class="button-linkStyle"
                @click="needToProviderDetails">{{getProvideMoreDetailsAction}} &#x00BB;</button>
        </div>
    </div>
</template>

<script>
import { getContactUsUrl } from 'services/metaData/links';

export default {
    name: 'NeedDetails',
    props: {
        hasAllowLiveAppFlag: {
            type: Boolean,
            default: false
        },
        isCompanyInfoMissing: {
            type: Boolean,
            default: true
        },
        isPaymentMethodMissing: {
            type: Boolean,
            default: true
        },
        isAppDetailsMissing: {
            type: Boolean,
            default: true
        },
        isWebApp: {
            type: Boolean,
            default: false
        },
        canGoLive: {
            type: Boolean,
            default: false
        },
        provideMoreDetailsDisabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            CONTACT_US: 'contactUs',
            PROVIDE_MORE_DETAILS: 'providerMoreDetails',
            contactUsLink: ''
        };
    },
    async created() {
        this.contactUsLink = await getContactUsUrl(true, 'Go Live');
    },
    computed: {
        messageKey() {
            const { canGoLive } = this;
            const allowLiveApp = (this.hasAllowLiveAppFlag && !this.isCompanyInfoMissing)
                    || !(this.isCompanyInfoMissing || this.isAppDetailsMissing)
                    || (this.isWebApp && !this.isCompanyInfoMissing);

            if (allowLiveApp && !canGoLive) {
                // if here it means that the application has all prerequisites to go live
                // but needs to contact us in order to go live
                return this.CONTACT_US;
            } if (!allowLiveApp) {
                return this.PROVIDE_MORE_DETAILS;
            }
            return null;
        },
        getProvideMoreDetailsAction() {
            if (this.isCompanyInfoMissing && !this.isPaymentMethodMissing &&
                (!this.isAppDetailsMissing || this.hasAllowLiveAppFlag)) {
                return 'fill in your Company Info';
            }
            return 'Provide More Details';
        }
    },
    methods: {
        needToProviderDetails() {
            this.$emit('provideMoreDetails');
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/buttons";

    .title{
        font-size: 15px;
        color: $light-700;
        margin-bottom: 5px;
    }

    .message{
        color: $light-700;
        line-height: 32px;
        button {
            margin-top: -2px;
        }
    }

    .wrap {
        height: 85px;
        width: 100%;
        border-top: 1px solid $light-500;
        padding-top: 43px;
        text-align: center;
        line-height: normal;
    }
</style>
